import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import PolarisFormProvider from '@container/PolarisFormProvider';
import SellerForm from './components/Form';

import { writeSimpleFieldsOnFormData } from 'utils';
import { SellerApplicationFormSchema } from 'utils/validationSchemas';
import axios from 'utils/axios';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  currencies: PropTypes.array.isRequired,
  salespoints: PropTypes.array.isRequired,
}

const defaultProps = {

}

const SellerApplicationFormNew = (props) => {

  const handleSubmit = async (values, formikBag) => {
    try {
      formikBag.setStatus({ submitLoading: true })
      const formData = new FormData();
      writeSimpleFieldsOnFormData(formData, "seller_application_form", values, { "catalog": "catalog" }); // Write

      const response = await axios.post(props.submitURL, formData);
      let { data, status } = response;
        formikBag.resetForm(); // Reset form!
        
        formikBag.setStatus({
          submitLoading: false,
          showToast: true,
          toastContent: I18n.t("app.messages.successful_seller_form")
        });
        // window.location = data.redirectURL;
        return true;
    } catch (error) {
      console.warn("E", error);
      const errors = error.response && error.response.data; 
      if(errors){
        formikBag.setStatus({
          submitLoading: false,
          showToast: true,
          toastContent: I18n.t("app.messages.record_errors")
        })
        console.log("Errors", errors)
        formikBag.setErrors(errors);
      }
    } // end catch
  }

  const defaultValues = { ...props.record, catalog: null, first_name: "", last_name: "", email: "", phone: "", company_name: "", legal_id: "", bank_account_number: "", address: "", commerce_information: "" }

  return (
    <PolarisFormProvider 
      validationSchema={ SellerApplicationFormSchema }
      title={ <strong>Aplicá a una cuenta de Seller</strong> }
      defaultValues={ defaultValues }
      submitURL={ props.submitURL }
      submitMethod="POST"
      handleSubmit={ handleSubmit }
    >
      { (renderProps) => <SellerForm salespoints={ props.salespoints } currencies={ props.currencies } {...renderProps} /> }
    </PolarisFormProvider>
  )
};

SellerApplicationFormNew.propTypes = propTypes;
SellerApplicationFormNew.defaultProps = defaultProps;

export default SellerApplicationFormNew;